export default  {
  en: {
    underhomepage1:{
      Recent:'Most Recent',
      Viewed:'Most Viewed',
      Liked:'Most Liked',
      introdu:"© 2018 Copyright purebabe.com. All rights reserved.",
      nodata:"no data",
    },
    threebar:{
      HOME:"HOME",
      MODEL:"MODEL",
      PHOTOS:"PHOTOS",
      MEMBERSHIP:"MEMBERSHIP",
      APP:"APP",
    },
    appinstall:{
      text1:"Take PureBabe with you",
      down1:"install",
    },
    models:{
        sortby:"Sort by",
        top:"Top",
        Newest:"Newest",
        Alphabetical:"Alphabetical",
    },
    headordby:{
      Usercenter:"Usercenter",
      Membership:"Membership",
      Liked:"Liked",
      Transaction:"Transaction",
      Logout:"Log out",
  },
  modelsinfo:{
      height:"Heights",
      B:"B",
      W:"W",
      H:"H",
      Subscribe:"Subscribe",
      PhotoGalleries:"Photo Galleries"
  },
  share:{
      cancel:"Cancel"
  },
  underhomepage1:{
      BuyNow:"Buy Now",
      WannAll:"Wanna It All?",
      addCoin:"Add Coins",
      Subscribe:"Subscribe (Best Value)",
  },
  payment:{
      Me:"Me",
      Transaction:"Transaction",
      nobuy:"You don't have any subscription Subscribe Now",
      vipnow:"Subscribe Now",
      Coins:"Coins",
      TTransaction:"Time of Transaction",
      TransactionID:"Transaction ID",
      status:"status"
  },
  membership:{
      Membership:"Membership",
      Me:"Me",
      Month:"Month",
      SelectPlan:"Select Plan",
      coins:"coins",
      Provide:"We Provide",
      trac:"100,000+ HD Photos",
      Compatible:"Compatible with all device",
      Safe :"Safe & secure transactions",
      DailyU:"Daily Updates",
      NoPop_Ups:"No Spam，No Pop-Ups"
        
  },
  buytype:{
      Pay:"Pay",
      Save:"Save",
      month:"/ month",
      Rebills:"Rebills yearly",
      sd:"One-time purchase@10888",
      OK:"OK",
      Cancel:"Cancel",
  },
  swichs:{
      Subscription:"Subscription",
      Coins:"Coins",
  },

    message: {
      hello: 'hello world',
      ww:{
          a:"HELLLLLO"
      }
    }
  },
  ja: {
    message: {
      hello: 'こんにちは、世界'
    }
  }
}




// WEBPACK FOOTER //
// ./src/language/en.js